<template>
	<svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3 7.584V5.616H15V7.584H3ZM0 0.599999H18V2.616H0V0.599999ZM6.984 12.6V10.584H11.016V12.6H6.984Z" fill="#9B9B9B" />
	</svg>
</template>
